import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetVersionQuery } from '../../../redux/api/staticApi'
import Alert from './../Alert/Alert'
import { useAuth } from '../../../auth/UseAuth'

export function VersionChecker() {
  const buildId = useRef<number | undefined>(undefined)
  const [versionChanged, setVersionChanged] = useState(false)
  const [alertVisible, setAlertVisible] = useState(false)
  const version = useGetVersionQuery(undefined, { pollingInterval: 60000, skip: versionChanged })
  const { user } = useAuth()
  const { t } = useTranslation()

  useEffect(() => {
    if (!version.data?.buildId) {
      return
    }
    if (!buildId.current) {
      buildId.current = version.data?.buildId
    } else if (buildId.current !== version.data.buildId) {
      setVersionChanged(true)
    }
  }, [version.data])

  useEffect(() => {
    if (versionChanged) {
      if (user?.isInternalUser) {
        setAlertVisible(true)
      } else {
        location.reload()
      }
    }
  }, [versionChanged, user?.isInternalUser])

  return (
    <Alert
      visible={alertVisible}
      onClose={() => location.reload()}
      title={t('INFO')}
      message={`${t('NEWER_APP_VERSION_AVAILABLE_DO_YOU_WANT_TO_RELOAD_THE_PAGE')}`}
    />
  )
}
